import {
  LANDING_SCREENSHOTS,
  type LandingScreenshotKey,
} from "@/content/landing-screenshots";
import { ProductPreviewFrame } from "./ProductPreviewFrame";

type LandingScreenshotPreviewProps = {
  screenshot: LandingScreenshotKey;
  className?: string;
};

export function LandingScreenshotPreview({
  screenshot,
  className = "",
}: LandingScreenshotPreviewProps) {
  const asset = LANDING_SCREENSHOTS[screenshot];

  return (
    <ProductPreviewFrame
      title={asset.frameTitle}
      badge={asset.badge}
      className={className}
    >
      <div className="relative overflow-hidden bg-[#12141c]">
        <picture>
          <source srcSet={asset.webp} type="image/webp" />
          <img
            src={asset.png}
            alt={asset.alt}
            width={asset.width}
            height={asset.height}
            loading="lazy"
            decoding="async"
            className={`block w-full object-cover object-top ${asset.maxHeightClass}`}
          />
        </picture>
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-[#12141c] via-[#12141c]/80 to-transparent"
          aria-hidden
        />
      </div>
    </ProductPreviewFrame>
  );
}
